define(function(require) {
    var $ = require('jquery');
    var cookie = require("cookie");

    $(function() {
        var $sticky = $(".sticky-wrapper.stuck");

        $(".personalization").on("click", ".close", function () {
            var cookieName = $(this).attr("data-cookie-name");
            // cookie.set('name', 'value');
            cookie.set(cookieName, true);
            // setTimeout(function(){
            if ($sticky.length) {
                $sticky.parent()
                    .css("display", "")
                    .css("padding-bottom", 0);
                $sticky.removeClass("active");
            }
            // }, 500);
        });

        if ($sticky.length) {
            $sticky.parent()
                .css("transition", "padding-bottom 0.3s")
                .css("padding-bottom", $sticky.outerHeight());
            $sticky.addClass("active");

            $(window).on("resize orientationchange", function(){
                $sticky.parent()
                    .css("padding-bottom", $sticky.outerHeight());
            });
        }
    });

});
